<div class="row">
	<div [class]="'col-12 ' + customOptions?.alignIconDiv">
		<button
			type="button"
			(click)="generatePDF()"
			[class]="'btn btn-outline-light btn-pdf ' + customOptions?.btnConfig?.btnClass"
			[pTooltip]="customOptions?.btnConfig?.tooltip | translate"
			[tooltipPosition]="customOptions?.btnConfig?.tooltipPosition"
		>
			<span *ngIf="customOptions?.btnConfig?.showText">{{
				customOptions?.btnConfig?.btnText | translate
			}}</span>
			<mat-icon class="pdf-icon" *ngIf="customOptions?.btnConfig?.showIcon">{{
				customOptions?.btnConfig?.icon
			}}</mat-icon>
		</button>
	</div>
</div>


